import { Number, Record, String } from 'runtypes';

export const AppointmentExtrasRunType = Record({
	from: String,
	id: Number,
	toi: String,
	uid: Number,
});
